import { render, staticRenderFns } from "./RequisitionPDFSamplesTable.vue?vue&type=template&id=89a399ea&scoped=true&"
import script from "./RequisitionPDFSamplesTable.vue?vue&type=script&lang=js&"
export * from "./RequisitionPDFSamplesTable.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionPDFSamplesTable.vue?vue&type=style&index=0&id=89a399ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a399ea",
  null
  
)

export default component.exports